import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "targetWrap", "oppositeOption"]

  connect() {
    this.update()
  }

  update() {
    const mode = this.hasModeTarget ? this.modeTarget.value : "off"
    if (this.hasTargetWrapTarget) {
      this.targetWrapTarget.classList.toggle("d-none", mode === "off")
    }
    if (this.hasOppositeOptionTarget) {
      this.oppositeOptionTarget.textContent = mode === "from_min" ? "Max" : "Empty (1)"
    }
  }
}
